// Reveals the cover image (and a play button when there is no link) if the browser refuses to autoplay.
(() => {
  const PAUSED_CHECK_DELAY = 800;

  const init = (root) => {
    if (root.hasAttribute('data-video-fallback-ready')) {
      return;
    }
    root.setAttribute('data-video-fallback-ready', '');

    const poster = root.querySelector('[data-video-fallback-poster]');
    const playButton = root.querySelector('[data-video-fallback-play]');

    if (!poster) {
      return;
    }

    const showPoster = () => {
      poster.hidden = false;
    };
    const hidePoster = () => {
      poster.hidden = true;
    };

    // native-video swaps the <template> in on play, so the <video> may not exist yet.
    const getVideo = () => root.querySelector('video');

    const bind = (video) => {
      if (!video || video.hasAttribute('data-video-fallback-bound')) {
        return;
      }
      video.setAttribute('data-video-fallback-bound', '');

      video.addEventListener('playing', hidePoster);
      video.addEventListener('pause', showPoster);

      const attempt = video.play();

      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(showPoster);
      }

      window.setTimeout(() => {
        if (video.paused) {
          showPoster();
        }
      }, PAUSED_CHECK_DELAY);
    };

    if (playButton) {
      playButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const video = getVideo();

        if (!video) {
          return;
        }

        const resumed = video.play();

        if (resumed && typeof resumed.catch === 'function') {
          resumed.catch(showPoster);
        }
      });
    }

    const video = getVideo();

    if (video) {
      bind(video);
      return;
    }

    // Wait for native-video to clone its <template> into the DOM.
    const observer = new MutationObserver(() => {
      const added = getVideo();

      if (added) {
        observer.disconnect();
        bind(added);
      }
    });

    observer.observe(root, { childList: true, subtree: true });
    window.setTimeout(() => observer.disconnect(), 5000);
  };

  const initAll = () => document.querySelectorAll('[data-video-fallback]').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }
})();
